import { graphql } from '../../../../graphql/generated';

export const COPY_CATALOG_PARAMETERS_MUTATION = graphql(`
  mutation CopyCatalogParametersMut($input: CopyCatalogParametersInput!) {
    copyCatalogParameters(input: $input)
  }
`);

export const COPY_CATALOG_PARAMETERS_QUERY = graphql(`
  query CopyCatalogParameters($catalogId: ID!, $labId: ID!) {
    catalog(id: $catalogId) {
      id
      name
      catalogParameters {
        id
        parameter {
          id
          shortName
          longName
        }
      }
    }

    labCatalogs(labId: $labId) {
      id
      name
    }
  }
`);
